import { HttpService } from 'core/modules/network-service';
import { get, merge } from 'lodash';

// local dependencies
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems } from 'resolvers/getVisibleEntities';
import { REDUCER } from 'constants/entity-names';
import { getStore } from 'store';

// get store
const store = getStore();

/*************************************************************/

/**
 * @type {class}
 * @desc Checkout defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { CheckoutService } from 'services/checkout';
 *
 * // create service instance and send/cancel request
 * const checkoutService = new CheckoutService();
 * const result = await checkoutService.fetchData( '<user-id>' ); // fetch data
 * checkoutService.cancel(); // cancel an active request
 */
export class CheckoutService extends HttpService {

    // make request and fetch component data
    async fetchComponentData( { url = {}, data = {} } = {} ) {

        const callerType = get( store.getState()[ REDUCER.CALL_STATE ], 'callerType', null );

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: merge( data,
                    {
                        context: {
                            callerType
                        }
                    }
                ),
            } );

            // extract data
            const visibility = get( response, 'body.component.visibility', {} );
            const steps = get( response, 'body.component.structure.steps', [] );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    steps: getVisibleItems( steps, visibility ),
                    currentStep: get( response, 'body.component.data.state.currentStep', 1 )
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
